import type { ReactNode } from 'react'
import { cx } from '../cx'
import styles from './Code.module.css'

/**
 * Inline code (`colour`: `accent-text` in the `code` role on the object rung).
 * For `page` grounds; not inside a `surface` card (D143).
 */
export function Code({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <code className={cx(styles.code, className)}>{children}</code>
}
